export default __webpack_public_path__ + "static/media/slack-background.339ead68.svg";